

































import {
  apiGroupBuyingOrderGroupOrderInfo,
  apiGroupBuyingOrderList,
} from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi } from '@/hooks'
import { default as GroupBuyingContent } from './content.vue'
import { default as GroupBuyingMore } from './more.vue'
import { default as GroupBuyingPendingPaymentOrder } from './pending_payment_order.vue'
import { prepareData } from '@/utils'

export default defineClassComponent<{
  /** 团单 ID */
  id: string
  showPendingPaymentOrder?: boolean
}>(
  {
    props: ['id', 'showPendingPaymentOrder'],
    components: {
      GroupBuyingContent,
      GroupBuyingMore,
      GroupBuyingPendingPaymentOrder,
    },
  },
  ({ props }) =>
    class {
      apiData = useApi(
        () =>
          prepareData({
            groupBuyingData: apiGroupBuyingOrderGroupOrderInfo({
              orderId: props.id,
            }),
            pendingPaymentOrderCount: props.showPendingPaymentOrder
              ? apiGroupBuyingOrderList(
                  {
                    orderStatus: 0,
                    pageIndex: 1,
                    pageSize: 1,
                  },
                  {
                    noErrorToast: true,
                    ignore403: true,
                  },
                ).then(
                  res => res.total,
                  () => 0,
                )
              : Promise.resolve(0),
          }),
        {
          refreshOnActivated: true,
        },
      )

      groupBuyingData = computed(() => this.apiData.data.groupBuyingData)

      pendingPaymentOrderCount = computed(
        () => this.apiData.data.pendingPaymentOrderCount,
      )

      handleCountdownEnd = () => {
        this.apiData.refresh()
      }
    },
)
